import "./App.css";
import "./my component/block_inspect"; // Disable right-click & dev tools
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./my component/Header"; // ✅ Fixed path with space
import Section1 from "./my component/section1";
import Section2 from "./my component/section2";
import Section3 from "./my component/section3";
import Section4 from "./my component/section4";
import FileCreation from "./my component/file";
import Notes from "./my component/notes";
import Services from "./my component/services";
import Upload from "./my component/Upload";

function Portfolio() {
  return (
    <>
      <Header title="My App logo" searchbar={true} />
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/file" element={<FileCreation />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/services" element={<Services />} />
        <Route path="/upload" element={<Upload />} />
      </Routes>
    </Router>
  );
}

export default App;
